import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.tiposdecosto.delete}
                postUrl={api.proyectos.config.presupuesto.tiposdecosto.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}

                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"El Tipo de Costo ha sido eliminado con éxito."}
                title={"Eliminar Tipo de Costo"}
                buttonTitle={"Eliminar Tipo de Costo"}
                buttonIcon={"fa fa-trash fa-lg"}

                saveButton={true}
                closeButton={true}
                danger={true}
                saveButtonLabel={"Eliminar"}
                buttonClass={"btn-danger"}
            >
                <ParadigmaLabeledInput disabled={true} fieldName="nombre" label="Nombre" labelColumns={2} fieldColumns={10} />
                <ParadigmaLabeledInput disabled={true} fieldName="siglas" label="Siglas" labelColumns={2} fieldColumns={10} />
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_TiposDeCosto/Delete.js